export default url => {
  if (url && typeof url === "string") {
    return url.replace("a.storyblok", "s3.amazonaws.com/a.storyblok")
  }
  return
}
